import {
  PRIORITIES_FETCH_REQUEST,
  PRIORITIES_FETCH_SUCCESS,
  PRIORITIES_FETCH_FAILURE,
  PRIORITIES_CLEAR
} from './prioritiesactions'

const INITIAL_STATE = {
  projetoId: null,
  limite: 20,
  grupos: [],
  itens: [],
  total: 0,
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRIORITIES_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case PRIORITIES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        projetoId: action.payload.projetoId,
        limite: action.payload.limite,
        grupos: action.payload.grupos,
        itens: action.payload.itens,
        total: action.payload.total
      }

    case PRIORITIES_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case PRIORITIES_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}